import React from 'react'

const Coins = () => {
    return (

        <div className="points-large-container">
            <div className="points-circle">$</div>
            <p className="points-large-number">1300</p>
        </div>
    )
}

export default Coins
